import type { SVGProps } from 'react';

const SvgAnnotationAnnotation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12.76 9.5c-1.36.22-1.29 1.11-1.06 2.47 0 0-2.5-.84-2.47.64.24 1.48 1.88 2.22 3.85 1.89 1.36-.22 2.77-1.59 2.55-2.95-.04-.24-.12-.47-.23-.68l5.22-5.51c.49-.41.5-1.17.02-1.6l-.56-.5c-.44-.4-1.13-.35-1.51.11l-4.93 6.14c-.28-.06-.58-.07-.88-.02z"
    />
    <path
      fill="currentcolor"
      d="M11.77 16.09c-.35-.43-.98-.5-1.41-.15-1.03.83-2.34 1-3.51.45-1.17-.56-1.86-1.68-1.86-3 0-3.1 3.14-5.62 7-5.62.34 0 .69.02 1.02.06.56.07 1.04-.33 1.11-.88.06-.55-.33-1.05-.88-1.11-.41-.05-.84-.07-1.26-.07-4.96 0-9 3.42-9 7.62 0 2.08 1.15 3.93 3 4.81.72.35 1.49.51 2.26.51 1.19 0 2.38-.41 3.37-1.21.43-.35.5-.98.15-1.41zm8.07-6.46a1.01 1.01 0 0 0-1.39-.28c-.46.31-.58.93-.28 1.39.55.82.83 1.71.83 2.64 0 1.35-.59 2.66-1.65 3.69-1.34 1.29-3.26 1.99-5.31 1.93h-.03c-.54 0-.98.43-1 .97-.02.55.41 1.01.97 1.03h.34c2.45 0 4.78-.9 6.43-2.49 1.46-1.41 2.26-3.23 2.26-5.13 0-1.32-.4-2.62-1.16-3.75z"
    />
  </svg>
);
export default SvgAnnotationAnnotation;
